<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body user-profile">
                                    <div class="page-wrapper">
                                        <!-- Page-header start -->
                                        <div class="page-header card">
                                            <div class="row align-items-end">
                                                <div class="col-lg-8">
                                                    <div class="page-header-title p-b-10">
                                                        <i class="icofont icofont-justify-all bg-c-green"></i>
                                                        <div class="d-inline">
                                                            <h4>Applicant Summary: {{applicant.firstname + " " +
                                                                applicant.lastname}}</h4>
                                                            <span>A comprehensive summary of the candidate.</span>
                                                            <br />
                                                            <span class="label" v-bind:class="label">
                                                                {{applicant.applicant_final_stage == undefined ? 'o' :
                                                                applicant.applicant_final_stage.description}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4 text-center">
                                                    <div>
                                                        <!--  -->
                                                        <span title="Send to HR Approver.">
                                                            <button v-if="$checkPerm('application.send_to_hiring_approver')"
                                                                class="btn btn-danger btn-outline-danger btn-icon m-1"
                                                                v-on:click="sendForApproval" v-bind:class="[isCurrent('0') ? 'btn-disabled disabled': 'animate']">
                                                                <i class="icofont icofont-read-book"></i>
                                                            </button>
                                                        </span>
                                                        <span title="Approve for hiring.">
                                                            <button v-if="$checkPerm('application.approve_hiring')"
                                                                class="btn btn-danger btn-outline-danger btn-icon m-1"
                                                                v-bind:class="[!isCurrent('1') ? 'btn-disabled disabled': 'animate']"
                                                                v-on:click="approveForHiring">
                                                                <i class="icofont icofont-ui-check"></i>
                                                            </button>
                                                        </span>
                                                        <span title="Forward offer letter to HR Approver.">
                                                            <button v-if="$checkPerm('application.forward_offer_to_approver')"
                                                                class="btn btn-warning btn-outline-warning btn-icon m-1"
                                                                v-bind:class="[!isCurrent('2') ? 'btn-disabled disabled': 'animate']"
                                                                data-toggle="modal" data-target="#fowardOfferLetter"
                                                                v-on:click="getOfferLetterByID">
                                                                <i class="icofont icofont-ui-file"></i>
                                                            </button>
                                                        </span>
                                                        <span title="Approve offer letter.">
                                                            <button v-if="$checkPerm('application.approve_offer')"
                                                                class="btn btn-info btn-outline-info btn-icon m-1"
                                                                v-bind:class="[!isCurrent('3') ? 'btn-disabled disabled': 'animate']"
                                                                data-toggle="modal" data-target="#approveOfferLetter"
                                                                v-on:click="getApplicantOfferLetter">


                                                                <i class="icofont icofont-ui-clip-board"></i>
                                                            </button>
                                                        </span>
                                                        <span title="Sent offer to candidate.">
                                                            <button v-if="$checkPerm('application.forward_offer_to_candidate')"
                                                                class="btn btn-primary btn-outline-primary btn-icon m-1"
                                                                :class="[!isCurrent('4') ? 'btn-disabled disabled': 'animate']"
                                                                @click="forwardLetterToApplicant">
                                                                <i class="icofont icofont-ui-message"></i>

                                                            </button>
                                                        </span>
                                                        <span title="Recruit Applicant (Post to HR Live).">
                                                            <button v-if="$checkPerm('application.recruit_hr_live')"
                                                                class="btn btn-success btn-outline-success btn-icon m-1"
                                                                v-bind:class="[!isCurrent('6') ? 'btn-disabled disabled': 'animate']"
                                                                v-on:click="recruitToHR">
                                                                <i class="icofont icofont-ui-add"></i>
                                                            </button>
                                                        </span>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Page-header end -->
                                        <!----<div class="alert alert-info icons-alert" v-show="duplicate_detected.length > 0">
                                           -<p>
                                                This applicant has applied 
                                                <strong>
                                                    <span v-if="duplicate_detected.length > 1">
                                                        {{duplicate_detected.length}} times
                                                    </span>
                                                    <span v-else>
                                                        once
                                                    </span>
                                                </strong>
                                                in the past 6 months.
                                            </p>
                                        </div>-->
                                        <!-- Page-body start -->
                                        <div class="page-body">

                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <!-- tab header start -->
                                                    <div class="tab-header card">
                                                        <ul class="nav nav-tabs md-tabs tab-timeline row" role="tablist"
                                                            id="mytab">
                                                            <li class="nav-item col-lg-2">
                                                                <a class="nav-link active f-12" data-toggle="tab" href="#personal"
                                                                    role="tab">About</a>
                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item col-lg-2">
                                                                <a class="nav-link f-12" data-toggle="tab" href="#binfo"
                                                                    role="tab">Documents & Videos</a>
                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item col-lg-2">
                                                                <a class="nav-link f-12" data-toggle="tab" href="#contacts"
                                                                    role="tab">CBT Scores</a>
                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item col-lg-2">
                                                                <a class="nav-link f-12" data-toggle="tab" href="#review"
                                                                    role="tab">Scorecard & Evaluation</a>
                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item col-lg-2" v-if="applicant.applicant_final_stage !== undefined && applicant.applicant_final_stage.id > 0">
                                                                <a class="nav-link f-12" data-toggle="tab" href="#note"
                                                                    role="tab">Conclusive Notes</a>
                                                                <div class="slide"></div>
                                                            </li>
                                                            <li class="nav-item col-lg-2">
                                                                <a class="nav-link f-12" data-toggle="tab" href="#letter"
                                                                    role="tab">Offer Letter</a>
                                                                <div class="slide"></div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <!-- tab header end -->
                                                    <!-- tab content start -->
                                                    <div class="tab-content">
                                                        <!-- tab panel personal start -->
                                                        <div class="tab-pane active" id="personal" role="tabpanel">
                                                            <About />
                                                        </div>
                                                        <!-- tab pane personal end -->
                                                        <!-- tab pane info start -->
                                                        <div class="tab-pane" id="binfo" role="tabpanel">
                                                            <DocumentsAndVideos />
                                                        </div>
                                                        <!-- tab pane info end -->
                                                        <!-- tab pane contact start -->
                                                        <div class="tab-pane" id="contacts" role="tabpanel">
                                                            <CBTScores />
                                                        </div>
                                                        <!-- tab pane contact end -->
                                                        <div class="tab-pane" id="review" role="tabpanel">
                                                            <ScorecardSummary />
                                                        </div>
                                                        <!-- tab pane contact end -->
                                                        <div class="tab-pane" id="note" role="tabpanel">
                                                            <FinalComments />
                                                        </div>
                                                        <!-- tab pane contact end -->
                                                        <div class="tab-pane" id="letter" role="tabpanel">
                                                            <OfferLetter :joblisting_id="job_id" />
                                                        </div>
                                                    </div>
                                                    <!-- tab content end -->
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Page-body end -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="fowardOfferLetter" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Forward For Approval</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="forwardLetterForApproval" v-if="templates.length > 0">
                            <div class="form-group">
                                <label>Template Name: </label>
                                <select class="form-control" v-model="applicant_offer.selected_template" v-on:change="updateSelectedTemplate">
                                    <option v-for="(template, index) in templates" v-bind:value="index">{{template.template_name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Template</label>
                                <summernote height="300" :model.sync="applicant_offer.template"></summernote>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success">Forward</button>
                            </div>
                        </form>

                        <div v-else>
                            <div class="alert alert-warning border-warning">
                                No offer templates found for this opening. You can create one to proceed.
                            </div>
                            <button class="btn btn-sm btn-primary" v-on:click="openTemplateWindow(applicant.joblistings.id)">Create
                                Template</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="approveOfferLetter" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Approve Offer</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="approveOffer">
                            <div class="form-group">
                                <label>Template</label>
                                <summernote height="300" :model.sync="approve_offer.template"></summernote>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success">Approve</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style type="text/css" scoped>
    .f-12 {
        font-size: 12px !important;
        font-weight: bold;
    }

    .slide {
        width: 90% !important;
    }

    @-webkit-keyframes blinker {
        from {
            opacity: 1.0;
        }

        to {
            opacity: 0.0;
        }
    }

    .blink {
        text-decoration: blink;
        -webkit-animation-name: blinker;
        -webkit-animation-duration: 0.6s;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: ease-in-out;
        -webkit-animation-direction: alternate;
    }

    .btn i {
        margin-right: 0px !important;
    }

    .btn-disabled {
        pointer-events: none;
    }

    .animate {
        animation-name: jump;
        animation-iteration-count: 5;
        animation-duration: 1.5s;
        animation-delay: 3s;
        animation-direction: alternate;
    }

    @keyframes jump {
        0% {
            margin-top: -50px;
        }

        50% {
            margin-top: 0px;
        }

        60% {
            margin-top: -10px;
        }

        90% {
            margin-top: 0px;
        }

        100% {
            margin-top: 0px;
        }
    }
</style>

<script type="text/javascript">
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import summernote from '../components/Summernote.vue'
    import { bus } from '../main'
    import OfferLetter from '../components/UserSummary/OfferLetter.vue'

    import About from '../components/UserSummary/About.vue'
    import DocumentsAndVideos from '../components/UserSummary/DocumentsAndVideos.vue'
    import CBTScores from '../components/UserSummary/CBTScores.vue'
    import ScorecardSummary from '../components/UserSummary/ScorecardSummary.vue'
    import FinalComments from '../components/UserSummary/FinalComments.vue'

    export default {
        name: 'UserSummary',
        data() {
            return {
                applicant: {
                    referrer_name: '',
                    documents: [
                        {
                            link: ""
                        }
                    ],
                    joblistings: {
                        id: "",
                        jobrole: {
                            name: ""
                        }
                    },
                    applicant_final_stage: {
                        description: "",
                        id: ""
                    }
                },
                joblistings_id: '',
                duplicate_detected: "",
                applicant_total_score: "",
                question_total_score: "",
                score_percent: "",
                scores: [],
                score_cards: [],
                score_card_average: 0,
                label: "",
                templates: [],
                applicant_offer: {
                    selected_template: "",
                    template: ""
                },
                approve_offer: {
                    template: "",
                    approved: false
                }
            }
        },
        components: {
            navbar1,
            navbar2,
            summernote,
            About,
            DocumentsAndVideos,
            CBTScores,
            ScorecardSummary,
            FinalComments,
            OfferLetter
        },
        methods: {

            init: function (applicant_id) {
                this.getApplicantById(applicant_id)
                this.duplicateDetection(applicant_id)
                this.getCbtAnswers(applicant_id)
                this.getAllScoreCards(applicant_id)
            },

            getApplicantById: function (id) {

                var applicant = {
                    what: 'GetApplicant',
                    id: id
                }

                this.$socket.makeGetRequest(applicant)
                    .then((response) => {
                        if (response.type = applicant.what) {
                            this.applicant = response.data
                            console.log(response.data)
                            this.applicantStatus()
                        }
                    })
                    .catch((error) => {

                    })
            },

            duplicateDetection: function (id) {

                let request = {
                    what: 'DuplicateDetection',
                    params: {
                        applicant_id: id
                    }
                }

                this.$socket.makeGetRequest(request)
                    .then((response) => {
                        if (response.type == "DuplicateDetection") {
                            this.duplicate_detected = response.data
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            getCbtAnswers: function (applicant_id) {

                let request = {
                    what: 'GetApplicantCBT',
                    params: {
                        applicant_id: applicant_id
                    }
                }

                this.$socket.makeGetRequest(request)
                    .then((response) => {
                        if (response.type == 'GetApplicantCBT') {
                            this.scoreAnswers(response.data)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            scoreAnswers: function (question) {
                /*
                    This functions, depending on the question type, compares the applicant answers with the question 
                    answers and creates an array of the scores.
                    AA = Applicant Answer
                    QA = Question Answer
                */

                let question_count = question.length

                //console.log(question[0])

                for (var i = 0; i < question_count; i++) {
                    switch (question[i].questiontype) {
                        case 'oa':
                        case 'sa':
                            /*
                                For these tests, we want to check if the AA vs QA values at the same
                                indexes tally. If all values tally, the applicant
                            */
                            if (JSON.stringify(question[i].applicant_answer).toLowerCase() == JSON.stringify(question[i].answers).toLowerCase()) {
                                this.scores[i] = {
                                    "score": parseInt(question[i].score)
                                }
                            } else {
                                this.scores[i] = {
                                    "score": 0
                                }
                            }
                            break;
                        case 'ma':
                            /*
                                For multiple answer questions, we want to check if items in the QA array are found in the AA
                                array.
                            
                            
                                Divide the score by the number of possible answers. For example, if the question score is
                                10 and there are 2 correct answers, that means each input is worth 5 marks (10/2 = 5)
                            */
                            var score = parseInt(question[i].score)

                            //The correct question answer
                            var qa = question[i].answers
                            var qa_len = qa.length

                            //Divide
                            var each_input = score / qa_len

                            //The applicant ansers
                            var aa = question[i].applicant_answer
                            var aa_len = aa.length



                            //A variable to hold an increment in scores as we compare each array index.
                            var temp_score = 0

                            for (var j = 0; j < qa_len; j++) {
                                //compare AA and QA arrays
                                if (aa.includes(qa[j])) {
                                    //Increase the temp score variable
                                    temp_score++
                                }
                            }

                            this.scores[i] = {
                                "score": temp_score
                            }


                            break;
                        case 'st':
                        case 'sj':
                            /*
                                For short text questions, we want to check if each index of AA tallies with 
                                the answer in each index of the QA.
                            
                            
                                Divide the score by the number of input fields. For example, if the question score is
                                20 and there are 2 blank inputs, that means each input is worth 10 marks (20/2 = 10)
                            */
                            //The score of the question
                            var score = parseInt(question[i].score)
                            //Number of inputs
                            var input_count = parseInt(question[i].inputs)
                            //Divide
                            var each_input = score / input_count

                            //The applicant ansers
                            var aa = question[i].applicant_answer
                            var aa_len = aa.length

                            //The correct question answer
                            var qa = question[i].answers
                            var qa_len = qa.length

                            //A variable to hold an increment in scores as we compare each array index.
                            var temp_score = 0

                            //If we are going to loop through 2 different arrays, using the same increment, we should
                            //check that they are the same length so we don't run into any errors (index not found type of error)
                            if (qa_len == aa_len) {
                                for (var j = 0; j < aa_len; j++) {
                                    //compare AA and QA arrays
                                    if (aa[j] == qa[j]) {
                                        //Increase the temp score variable
                                        temp_score++
                                    }
                                }

                                this.scores[i] = {
                                    "score": temp_score
                                }

                            } else {
                                this.scores[i] = {
                                    "score": 0
                                }
                            }

                            break;
                        default:
                            this.scores[i] = {
                                "score": 0
                            }
                            break;
                    }
                }

                this.applicant_total_score = this.calculateTotal(this.scores, "score")
                this.question_total_score = this.calculateTotal(question, "score")
                this.score_percent = parseFloat((this.applicant_total_score * 100) / this.question_total_score).toFixed(2)
            },

            calculateTotal: function (score_array, key) {
                let total = 0
                let sa_length = score_array.length

                for (var i = 0; i < sa_length; i++) {
                    total = total + parseInt(score_array[i][key])
                }

                return total
            },

            getAllScoreCards: function (applicant_id) {

                var scorecards = {
                    what: 'ApplicantScorecard',
                    params: {
                        appID: applicant_id
                    }
                }

                this.$socket.makeGetRequest(scorecards)
                    .then((response) => {
                        if (response.type == 'ApplicantScorecard') {
                            this.score_cards = response.data

                            var cumulative = 0

                            for (var h = 0; h < this.score_cards.length; h++) {
                                var evals = this.score_cards[h].evaluations
                                var score = 0
                                for (var i = 0; i < evals.length; i++) {
                                    score = score + parseInt(evals[i].score)
                                }
                                cumulative = cumulative + score
                            }

                            this.score_card_average = cumulative / this.score_cards.length
                        }

                    })
                    .catch((e) => {
                        console.log(e)
                    })
            },

            applicantStatus: function () {
                var res = ""

                switch (this.applicant.applicant_final_stage.id) {
                    case 1:
                        res = "label-inverse-danger blink"
                        break;
                    case 2:
                        res = "label-inverse-warning blink"
                        break;
                    case 3:
                        res = "label-inverse-info blink"
                        break;
                    case 4:
                        res = "label-inverse-primary"
                        break;
                    case 5:
                        res = "label-inverse-success"
                        break;
                    case 6:
                        res = "label-inverse-success"
                        break;
                    case 7:
                        res = "label-inverse-success"
                        break;
                    default:
                        // statements_def
                        break;
                }

                this.label = res
            },

            isCurrent: function (num) {
                //Return true if num is equal to applicant current recruitment status.
                if (num == 0) {
                    if (this.applicant.applicant_final_stage == undefined) {
                        return false
                    } else {
                        return true
                    }
                    //return false
                } else {
                    if (this.applicant.applicant_final_stage !== undefined) {
                        return num == parseInt(this.applicant.applicant_final_stage.id)
                    } else {
                        return false
                    }
                }


            },

            sendForApproval: function () {
                var request = {
                    what: 'ProgressApplicant',
                    data: {
                        applicant_id: this.$route.params.id,
                        stage: '1'
                    }
                }

                var c = confirm("Send this application to HR Approver? This action cannot be reversed.")

                if (c) {
                    this.$socket.makePostRequest(request)
                        .then((response) => {
                            if (response.type == request.what) {
                                this.$swal.fire("Success", "Applicant profile sent for review.", "success")
                            }

                            setTimeout(window.location.reload(), 2000)
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            },

            approveForHiring: function () {
                var request = {
                    what: 'ProgressApplicant',
                    data: {
                        applicant_id: this.$route.params.id,
                        stage: '2'
                    }
                }

                var c = confirm("Approve this applicant for hiring? This action cannot be reversed.")

                if (c) {
                    this.$socket.makePostRequest(request)
                        .then((response) => {
                            if (response.type == request.what) {
                                this.$swal.fire("Success", "Applicant approved for hiring.", "success")
                            }

                            setTimeout(window.location.reload(), 2000)
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            },

            forwardLetterForApproval: function () {
                this.applicant_offer.applicant_id = this.applicant.id
                this.applicant_offer.joblisting_id = this.applicant.joblisting_id
                this.applicant_offer.jobrole_name = this.applicant.joblistings.jobrole.name

                let sendOL = {
                    what: 'SendOfferLetter',
                    data: this.applicant_offer
                }

                this.$socket.makePostRequest(sendOL)
                    .then((response) => {
                        if (response.type == "SendOfferLetter") {
                            this.$swal.fire("Success", "Offer letter sent for approval.", 'success')

                            //Route the applicant to stage 3: Pending offer acceptance.
                            var request = {
                                what: 'ProgressApplicant',
                                data: {
                                    applicant_id: this.$route.params.id,
                                    stage: '3'
                                }
                            }

                            this.$socket.makePostRequest(request)
                                .then((response) => {
                                    if (response.type == request.what) {
                                        this.$swal.fire("Success", "Applicant offer letter sent for approval.", "success")
                                    }

                                    setTimeout(window.location.reload(), 3000)

                                })
                                .catch((error) => {
                                    console.log(error)
                                })

                        }
                    })
                    .catch((error) => {
                        this.$swal.fire('Error', error.message, 'error')
                        //console.log(error)
                    })
            },

            getOfferLetterByID: function () {
                var applicant = {
                    what: 'GetOfferForRole',
                    params: {
                        "joblisting_id": this.applicant.joblistings.id
                    }
                }

                this.$socket.makeGetRequest(applicant)
                    .then((response) => {
                        if (response.type = applicant.what) {
                            this.templates = response.data
                            console.log(response.data)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            getApplicantOfferLetter: function () {
                var applicant = {
                    what: 'GetOfferForApplicant',
                    params: {
                        "joblisting_id": this.applicant.joblistings.id,
                        "applicant_id": this.$route.params.id
                    }
                }

                this.$socket.makeGetRequest(applicant)
                    .then((response) => {
                        if (response.type = applicant.what) {
                            this.approve_offer.template = response.data.template

                            bus.$emit('updateText', response.data.template)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            approveOffer: function () {
                this.approve_offer.applicant_id = this.applicant.id
                this.approve_offer.joblisting_id = this.applicant.joblisting_id
                this.approve_offer.jobrole_name = this.applicant.joblistings.jobrole.name
                this.approve_offer.approved = true
                var c = confirm("Are you sure you want to go ahead and approve the offer? ")
                if (c) {
                    let sendOL = {

                        what: 'SendOfferLetter',
                        data: this.approve_offer
                    }

                    this.$socket.makePostRequest(sendOL)
                        .then((response) => {
                            if (response.type == "SendOfferLetter") {
                                this.$swal.fire("Success", "Offer letter approved.", 'success')

                                //Route the applicant to stage 4: Pending offer acceptance.
                                var request = {
                                    what: 'ProgressApplicant',
                                    data: {
                                        applicant_id: this.$route.params.id,
                                        stage: '4'
                                    }
                                }

                                this.$socket.makePostRequest(request)
                                    .then((response) => {
                                        if (response.type == request.what) {
                                            this.$swal.fire("Success", "Applicant offer letter approved.", "success")
                                        }

                                        setTimeout(window.location.reload(), 3000)

                                    })
                                    .catch((error) => {
                                        console.log(error)
                                    })

                            }

                        })
                        .catch((error) => {
                            this.$swal.fire('Error', error.message, 'error')
                            //console.log(error)
                        })
                }
            },

            openTemplateWindow: function (id) {
                $('.modal').modal('hide')
                window.open('/createoffertemplate/' + id)
            },

            updateSelectedTemplate: function () {
                this.applicant_offer.template = this.templates[this.applicant_offer.selected_template].body

                bus.$emit('updateText', this.applicant_offer.template)
            },

            recruitToHR: function () {
                var request = {
                    what: "RecruitToHR",
                    data: {
                        "applicant_id": this.$route.params.id
                    }
                }

                this.$socket.makePostRequest(request)
                    .then((response) => {
                        if (response.type == request.what) {
                            this.$swal.fire("Success", "Applicant details synced to HR Live.", "success")
                        }

                        setTimeout(window.location.reload(), 3000)

                    })
                    .catch((error) => {
                        this.$swal.fire("Error", error.message, "error")
                        console.log(error)
                    })
            },

            forwardLetterToApplicant: function () {
                var request = {
                    what: "ForwardLetterToApplicant",
                    data: {
                        "applicant_id": this.$route.params.id
                    }
                }
                console.log(request);

                this.$socket.makePostRequest(request)
                    .then((response) => {
                        if (response.type == "ForwardLetterToApplicant") {
                            this.$swal.fire("Success", "Letter forwarded to candidate", "success")
                        }

                        //setTimeout(window.location.reload(), 3000)
                        //Route the applicant to stage 4: Pending offer acceptance.
                        var request = {
                            what: 'ProgressApplicant',
                            data: {
                                applicant_id: this.$route.params.id,
                                stage: '5'
                            }
                        }

                        this.$socket.makePostRequest(request)
                            .then((response) => {
                                if (response.type == request.what) {
                                    this.$swal.fire("Success", "Letter forwarded to candidate.", "success")
                                }

                                setTimeout(window.location.reload(), 3000)

                            })
                            .catch((error) => {
                                console.log(error)
                            })

                    })
                    .catch((error) => {
                        this.$swal.fire("Error", error.message, "error")
                        console.log(error)
                    })

            }

        },

        mounted() {
            var id = this.$route.params.id

            this.init(id)
        },

        computed: {
            job_id() {
                return this.applicant.joblistings.id;
            },
            // template() {
            //     return this.template;
            // }
        }
    }
</script>